<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" :tbody-tr-class="rowClass">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "AamsUnitRegInfoBankDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'bankName', label: '开户银行', width: '200px'},
        {key: 'bankAccount', label: '账号', width: '200px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data || '[]')
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    rowClass() {
      return 'row-center'
    },
  }
}
</script>

<style scoped>
::v-deep .row-center td {
  vertical-align: middle;
}
</style>
